
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ModalComponent, ModalHeaderComponent, ModalBodyComponent, ModalFooterComponent, AutofocusDirective, MODAL_DIRECTIVES } from './index';

@NgModule({
    imports: [CommonModule],
    declarations: [ModalComponent, ModalHeaderComponent, ModalBodyComponent, ModalFooterComponent, AutofocusDirective],
    exports: [ModalComponent, ModalHeaderComponent, ModalBodyComponent, ModalFooterComponent, AutofocusDirective]
})
export class ModalComponentModule { }



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/shared/modeldialog/model-dialog.module.ts